import { IBenefit } from 'src/interfaces';
import { BenefitsActionType } from '../action-types';
import { BenefitsAction } from '../actions';

interface BenefitsState {
  loading: boolean;
  error: string | null;
  data: { benefits: IBenefit[] };
}

const initialState = {
  loading: false,
  error: null,
  data: { benefits: [] },
};

const reducer = (state: BenefitsState = initialState, action: BenefitsAction): BenefitsState => {
  switch (action.type) {
    case BenefitsActionType.GET_BENEFITS:
      return { loading: true, error: null, data: { benefits: [] } };
    case BenefitsActionType.GET_BENEFITS_SUCCESS:
      return { loading: false, error: null, data: action.payload };
    case BenefitsActionType.GET_BENEFITS_FAILURE:
      return { loading: false, error: action.payload, data: { benefits: [] } };
    default:
      return state;
  }
};

export default reducer;
